import { CLEAR_MESSAGE, LOGIN, LOGIN_ERROR, LOGIN_SUCCESS, LOGOUT } from '../actions/login';

const initialState = { loggingIn: true, message: null, isBankStaff: false, isFSC: false, isBOTO: false };

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN:
      return { ...state, loggingIn: true };
    case LOGIN_SUCCESS:
      let authorities = (payload?.authorities || []).map((e) => e?.authority);
      let isBankStaff = (authorities || []).includes('ROLE_BANKSTAFF');
      let isFSC = (authorities || []).includes('ROLE_FSC');
      let isBO = (authorities || []).includes('ROLE_BO');
      let isTO = (authorities || []).includes('ROLE_TO');
      let isHO = (authorities || []).includes('ROLE_HO');
      let isBPBankfee = (authorities || []).includes('ROLE_BP_BANKFEE');
      let isBPContest = (authorities || []).includes('ROLE_BP_CONTEST');
      let isBPReport = (authorities || []).includes('ROLE_BP_REPORT');
      let isBPAdmin = (authorities || []).includes('ROLE_BP_ADMIN');
      return { ...state, ...payload, loggingIn: false, isBankStaff, isFSC, isBO, isTO, isHO, isBPBankfee, isBPContest, isBPReport, isBPAdmin };

    case LOGOUT:
      return { ...initialState };

    case LOGIN_ERROR:
      return { ...state, message: payload?.message };

    case CLEAR_MESSAGE:
      return { ...state, message: null };

    case 'CHANGE_USERNAME':
      let currentUsername = state?.loginUsername;
      return { ...state, loginUsername: payload?.newUsername || currentUsername };

    default:
      return { ...state, loggingIn: false };
  }
};

export default authReducer;
